import { Center, HStack, Text } from '@chakra-ui/react';
import { QuestionMarkIcon } from 'components/Icons/QuestionMarkIcon';
import { AppLink } from 'components/Link/AppLink';
import COLORS from 'constants/colors';

export const InstructionCallout = ({
  link,
  checkPermissions,
  innerHtmlToScroll,
  children,
  appName,
  providerDisplayName,
}: {
  link: string;
  checkPermissions?: boolean;
  innerHtmlToScroll?: string;
  children?: React.ReactNode;
  appName?: string;
  providerDisplayName?: string;
}) => {
  // Render the manual sign-in variant when both appName and providerDisplayName are provided
  const renderManualSignInContent = () => (
    <>
      To connect your {providerDisplayName} account, you must add{' '}
      <strong>{appName}</strong> as an admin to your payroll system. Open{' '}
      <AppLink
        href={link}
        rel="noreferrer"
        target="_blank"
        showInFrame
        innerHtmlToScroll={innerHtmlToScroll}
      >
        this guide
      </AppLink>{' '}
      to complete the steps.
    </>
  );

  // Render the default content
  const renderDefaultContent = () => (
    <>
      Need help? Follow{' '}
      <AppLink
        href={link}
        rel="noreferrer"
        target="_blank"
        showInFrame
        innerHtmlToScroll={innerHtmlToScroll}
      >
        Finch&apos;s instructions
      </AppLink>{' '}
      {checkPermissions
        ? 'to learn how to check your permissions.'
        : 'to complete these steps.'}
    </>
  );

  const getContent = () => {
    if (children) return children;
    if (appName && providerDisplayName) return renderManualSignInContent();
    return renderDefaultContent();
  };

  return (
    <HStack
      align="flex-start"
      px="3"
      py="2"
      mb="2"
      borderRadius="8px"
      bg={COLORS.GRAY.GRAY_200}
      color={COLORS.FINCH.BLACK}
      fontSize="14px"
      borderColor={COLORS.GRAY.GRAY_400}
      borderWidth="1px"
      gap="2"
    >
      <Center boxSize="20px" mt="1">
        <QuestionMarkIcon />
      </Center>
      <Text textAlign="left">{getContent()}</Text>
    </HStack>
  );
};
